<template>
  <div class="item_description">
    <textarea
      class="textarea"
      full-width
      v-if="userAuthority === 'MANAGER' && isUnderEditing"
      v-model.lazy="inputText"
    ></textarea>
    <p class="text" v-else>{{ inputText }}</p>
  </div>
</template>

<script>
export default {
  name: "CheckListItemDescription",
  data: () => ({}),
  methods: {},
  computed: {
    inputText: {
      get() {
        return this.text;
      },
      set(value) {
        this.$emit("update:text", value);
      }
    }
  },
  created() {},
  components: {},
  props: ["text", "userAuthority", "isUnderEditing"]
};
</script>

<style scoped>
.item_description {
  font-weight: bold;
  font-size: 0.8em;
  border: 1px solid #cdd6dd;
  background-color: #fff;
  text-align: left;
  width: 100%;
  margin: 2px 0;
  padding: 0;
}
.text {
  display: inline-block;
  vertical-align: middle;
  margin: 0;
  color: #707f89;
  padding: 10px;
}
.textarea {
  width: 100%;
  color: #707f89;
  padding: 4px;
}
</style>
